/**
 * Mirenea Picker Patch v1.1
 * AUFGABE 1: Oxycreme-Reminder Trigger bei Farbwechsel
 * AUFGABE 2: Farbton-Auswahl als Drawer von rechts
 *
 * Aenderung 21.09.2026 (Performance):
 * - Kachelbilder bekommen width/height und aspect-ratio. Ohne diese Angaben
 *   kann der Browser das Layout nicht vorberechnen; Google bricht die
 *   LCP-Messung mit NO_LCP ab. 60 Kacheln waren betroffen.
 * - Kachelbilder bekommen einen echten alt-Text statt alt="". Behebt den
 *   Barrierefreiheits-Befund "Bildelemente haben keine [alt]-Attribute".
 */
(function() {
  'use strict';

  function initReminderTrigger() {
    var oxyReminder = document.querySelector('#mbp-oxy-reminder');
    if (!oxyReminder) return;

    function updateReminder() {
      var activeCard = document.querySelector('.mbp-set-card.active');
      var isOnly = activeCard && activeCard.dataset.set === 'only';
      var colorSelect = document.querySelector('select[name="options[Farbton]"]');
      var hasColor = colorSelect && colorSelect.value !== '';
      if (isOnly && hasColor) {
        oxyReminder.classList.add('visible');
      } else if (!isOnly) {
        oxyReminder.classList.remove('visible');
      }
    }

    var colorSelect = document.querySelector('select[name="options[Farbton]"]');
    if (colorSelect) colorSelect.addEventListener('change', updateReminder);

    var setCardsEl = document.querySelector('.mbp-set-cards');
    if (setCardsEl) {
      setCardsEl.addEventListener('click', function() { setTimeout(updateReminder, 60); });
    } else {
      document.querySelectorAll('.mbp-set-card').forEach(function(card) {
        card.addEventListener('click', function() { setTimeout(updateReminder, 60); });
      });
    }
    updateReminder();
  }

  function initColorDrawer() {
    if (document.getElementById('mirenea-color-drawer')) return;

    var styleCSS = [
      '.mbp-swatches-panel{display:none!important}',
      '#mirenea-color-drawer-overlay{position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.45);z-index:9998;opacity:0;pointer-events:none;transition:opacity .3s}',
      '#mirenea-color-drawer-overlay.mcd-open{opacity:1;pointer-events:all}',
       '#mirenea-color-drawer{position:fixed;top:0;right:0;width:400px;max-width:95vw;height:100vh;background:#fff;z-index:9999;box-shadow:-4px 0 24px rgba(0,0,0,.18);display:flex;flex-direction:column;transform:translateX(100%)}',     '.mcd-header{display:flex;align-items:center;justify-content:space-between;padding:20px 18px 14px;border-bottom:1px solid #f2e4ea;flex-shrink:0}',
      '#mirenea-color-drawer.mcd-open{transform:translateX(0)}',
      '.mcd-header-title{font-size:17px;font-weight:700;color:#1a1a1a;margin:0}',
      '.mcd-close-btn{background:none;border:none;cursor:pointer;width:34px;height:34px;border-radius:50%;display:flex;align-items:center;justify-content:center;color:#555;font-size:19px;transition:background .15s}',
      '.mcd-close-btn:hover{background:#f5f5f5}',
      '.mcd-search-wrap{padding:11px 18px;border-bottom:1px solid #f2e4ea;flex-shrink:0}',
      '.mcd-search{width:100%;padding:9px 12px 9px 34px;border:1.5px solid #e0e0e0;border-radius:8px;font-size:14px;outline:none;box-sizing:border-box;background:#fafafa}',
      '.mcd-search:focus{border-color:#b2476e;background:#fff}',
      '.mcd-grid-wrap{flex:1;overflow-y:auto;padding:14px 18px 20px;-webkit-overflow-scrolling:touch}',
      '.mcd-count{font-size:12px;color:#888;margin-bottom:10px}',
      '.mcd-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:9px}',
      '.mcd-tile{border:2px solid #ebebeb;border-radius:10px;padding:11px 7px 9px;cursor:pointer;text-align:center;transition:border-color .15s,box-shadow .15s,transform .1s;background:#fff;position:relative}',
      '.mcd-tile:hover{border-color:#b2476e;transform:translateY(-1px);box-shadow:0 3px 10px rgba(178,71,110,.12)}',
      '.mcd-tile.mcd-selected{border-color:#b2476e;box-shadow:0 0 0 2px #b2476e;background:#fff5f7}',
      '.mcd-tile-img{width:50px;height:50px;aspect-ratio:1/1;border-radius:50%;object-fit:cover;border:2px solid #f0e4e9;display:block;margin:0 auto 7px}',
      '.mcd-tile-code{font-size:11px;color:#b2476e;font-weight:600;margin-bottom:2px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}',
      '.mcd-tile-name{font-size:11px;color:#555;line-height:1.3;overflow:hidden}',
      '.mcd-check{position:absolute;top:5px;right:5px;width:17px;height:17px;border-radius:50%;background:#b2476e;color:#fff;display:none;align-items:center;justify-content:center;font-size:10px;font-weight:700}',
      '.mcd-tile.mcd-selected .mcd-check{display:flex}',
      '.mcd-no-results{text-align:center;color:#aaa;padding:40px 20px;font-size:14px;display:none}'
    ].join('');
    var style = document.createElement('style');
    style.textContent = styleCSS;
    document.head.appendChild(style);

    var origSwatches = Array.from(document.querySelectorAll('.mbp-swatch'));
    var swatchData = origSwatches.map(function(s) {
      var img = s.querySelector('img');
      var name = (s.dataset.variantTitle || '').trim();
      var parts = name.split(' ');
      return { variantId: s.dataset.variantId, title: name, code: parts[0]||'', label: parts.slice(1).join(' '), imgSrc: img ? img.src : '' };
    });

    var tilesHTML = swatchData.map(function(d) {
      var altText = d.title ? ('Mirenea Haarfarbe ' + d.title) : 'Mirenea Haarfarbe';
      return '<div class="mcd-tile" data-variant-id="' + d.variantId + '" data-title="' + d.title.replace(/"/g,'&quot;') + '">' +
        '<span class="mcd-check">&#10003;</span>' +
        '<img class="mcd-tile-img" src="' + d.imgSrc + '" alt="' + altText.replace(/"/g,'&quot;') + '" width="50" height="50" loading="lazy" decoding="async">' +
        '<div class="mcd-tile-code">' + d.code + '</div>' +
        '<div class="mcd-tile-name">' + d.label + '</div></div>';
    }).join('');

    var overlay = document.createElement('div');
    overlay.id = 'mirenea-color-drawer-overlay';
    document.body.appendChild(overlay);

    var drawer = document.createElement('div');
    drawer.id = 'mirenea-color-drawer';
    drawer.innerHTML = '<div class="mcd-header"><h2 class="mcd-header-title">&#127912; Farbton wählen</h2><button class="mcd-close-btn" id="mcd-close-btn" aria-label="Schließen">✕</button></div>' +
      '<div class="mcd-search-wrap"><input type="search" class="mcd-search" id="mcd-search" placeholder="Farbton suchen..." autocomplete="off"></div>' +
      '<div class="mcd-grid-wrap"><div class="mcd-count" id="mcd-count">' + swatchData.length + ' Farbtöne</div><div class="mcd-grid" id="mcd-grid">' + tilesHTML + '</div><div class="mcd-no-results" id="mcd-no-results">Keine Farbtöne gefunden</div></div>';
    document.body.appendChild(drawer);

    var colorSelect = document.querySelector('select[name="options[Farbton]"]');
    var triggerBtn = document.querySelector('.mbp-color-trigger-btn');
    var grid = document.getElementById('mcd-grid');
    var countEl = document.getElementById('mcd-count');
    var noResults = document.getElementById('mcd-no-results');
    var searchInput = document.getElementById('mcd-search');
    var closeBtn = document.getElementById('mcd-close-btn');

    function openDrawer() { overlay.classList.add('mcd-open'); drawer.classList.add('mcd-open'); document.body.style.overflow='hidden'; setTimeout(function(){searchInput.focus();},100); updateSelectedTile(); }
    function closeDrawer() { overlay.classList.remove('mcd-open'); drawer.classList.remove('mcd-open'); document.body.style.overflow=''; }
    function updateSelectedTile() { var cur = colorSelect ? colorSelect.value : null; grid.querySelectorAll('.mcd-tile').forEach(function(t){ t.classList.toggle('mcd-selected', t.dataset.title === cur); }); }

    function handleTileClick(tile) {
      var id = tile.dataset.variantId; var title = tile.dataset.title;
      if (colorSelect) { colorSelect.value = title; colorSelect.dispatchEvent(new Event('change',{bubbles:true})); }
      var orig = origSwatches.find(function(s){ return s.dataset.variantId===id||s.dataset.variantTitle===title; });
      if (orig) orig.click();
      grid.querySelectorAll('.mcd-tile').forEach(function(t){ t.classList.toggle('mcd-selected', t===tile); });
      setTimeout(closeDrawer, 200);
    }

    function handleSearch() {
      var q = searchInput.value.toLowerCase().trim(); var cnt=0;
      grid.querySelectorAll('.mcd-tile').forEach(function(t){ var m=!q||(t.dataset.title||'').toLowerCase().includes(q); t.style.display=m?'':'none'; if(m)cnt++; });
      countEl.textContent=cnt+' Farbtöne'+(q?' gefunden':'');
      noResults.style.display=cnt===0?'block':'none';
    }

    if (triggerBtn) triggerBtn.addEventListener('click', function(e){ e.stopPropagation(); openDrawer(); });
    closeBtn.addEventListener('click', closeDrawer);
    overlay.addEventListener('click', closeDrawer);
    searchInput.addEventListener('input', handleSearch);
    grid.addEventListener('click', function(e){ var t=e.target.closest('.mcd-tile'); if(t) handleTileClick(t); });
    document.addEventListener('keydown', function(e){ if(e.key==='Escape'&&drawer.classList.contains('mcd-open')) closeDrawer(); });
    if (colorSelect) colorSelect.addEventListener('change', updateSelectedTile);
    document.querySelectorAll('.mbp-set-card').forEach(function(c){ c.addEventListener('click', function(){ setTimeout(updateSelectedTile,60); }); });
  }

  function init() { initReminderTrigger(); initColorDrawer(); }
  if (document.readyState==='loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();